import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import { CoachNode } from 'src/generated/webapp_gql';
import { Role } from 'src/modules/user/models/user';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

import { ScheduleSessionCalendarPageComponent } from './ScheduleSessionCalendarPage';

type Props = RouteComponentProps<{ coachUuid: string }>;

const ScheduleSessionReadonlyCalendarPage: React.FC<Props> = ({ match, history }) => {
    const { coachUuid } = match.params;

    const user = useSelector(getUserInformation);
    const isMember = user?.role === Role.MEMBER;

    useEffect(() => {
        if (coachUuid && isMember) {
            history.replace('/schedule-session/calendar', {
                coachUuid,
            });
        } else if (!coachUuid || user?.uuid !== coachUuid) {
            history.replace('/dashboard');
        }
    }, [coachUuid, history, isMember, user]);

    if (!user || isMember) {
        return null;
    }

    return (
        <ScheduleSessionCalendarPageComponent
            history={history}
            provider={user as unknown as CoachNode}
            readonly
        />
    );
};

export default ScheduleSessionReadonlyCalendarPage;
